import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Typography,
  Box,
  Chip,
} from '@mui/material';
import { History as HistoryIcon, Person as PersonIcon } from '@mui/icons-material';

const LogHistoryDialog = ({ open, log, onClose }) => {
  if (!log) return null;

  const getStatusColor = (status) => {
    const colors = {
      new: 'info',
      'in-progress': 'warning',
      'waiting-client': 'secondary',
      completed: 'success',
    };
    return colors[status] || 'default';
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Status History: {log.title}</DialogTitle>
      <DialogContent>
        {log.statusHistory && log.statusHistory.length > 0 ? (
          <List>
            {log.statusHistory.map((entry, idx) => (
              <ListItem key={idx} divider alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: `${getStatusColor(entry.status)}.main` }}>
                    <HistoryIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                      <Typography variant="subtitle1" component="span" fontWeight={500}>
                        Status changed to: {entry.status}
                      </Typography>
                      <Chip
                        label={entry.status}
                        size="small"
                        color={getStatusColor(entry.status)}
                      />
                    </Box>
                  }
                  secondary={
                    <Box component="span" sx={{ display: 'block', mt: 1 }}>
                      <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <PersonIcon fontSize="small" color="action" />
                        <Typography variant="caption" component="span" color="textSecondary">
                          Changed by: {entry.changedBy?.fullName || 'Unknown'}
                        </Typography>
                        <Typography variant="caption" component="span" color="textSecondary">
                          at {formatDate(entry.changedAt)}
                        </Typography>
                      </Box>
                      {entry.notes && (
                        <Box component="div" sx={{ mt: 1, p: 1, bgcolor: 'action.hover', borderRadius: 1 }}>
                          <Typography variant="body2" component="p">
                            <strong>Notes:</strong> {entry.notes}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography color="textSecondary">
              No status changes recorded.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogHistoryDialog;